angular.module('accessWebClient')
    .factory('StepByStepService', [function () {
        return function StepByStep(steps) {
            var current = 0;

            Object.defineProperty(this, 'step', {
                get: function () {
                    return current !== -1 ? steps[current] : null;
                }
            });

            this.next = function () {
                return current = current < steps.length - 1 ? current + 1 : -1;
            };
        }
    }]);
